export const SAGA_GET_COUNTRY_BY_NAME = 'SAGA_GET_COUNTRY_BY_NAME';
export const FETCH_COUNTRY_SUCCESS = 'FETCH_COUNTRY_SUCCESS';

export const SAGA_GET_ALL_COUNTRIES = 'SAGA_GET_ALL_COUNTRIES';
export const FETCH_COUNTRIES_SUCCESS = 'FETCH_COUNTRIES_SUCCESS';

export const SAGA_ADD_FAVORITE_COUNTRY = 'SAGA_ADD_FAVORITE_COUNTRY';
export const SAGA_REMOVE_FAVORITE_COUNTRY = 'SAGA_REMOVE_FAVORITE_COUNTRY';
export const SET_FAVORITE_COUNTRY = 'SET_FAVORITE_COUNTRY';

export const SAGA_GET_FAVORITE_COUNTRY = 'SAGA_GET_FAVORITE_COUNTRY';
export const GET_FAVORITE_COUNTRY = 'GET_FAVORITE_COUNTRY';

export const SEARCH_COUNTRY = 'SEARCH_COUNTRY';
export const FILTER_COUNTRY = 'FILTER_COUNTRY';

export const GET_FILTER_INPUT = 'GET_FILTER_INPUT';
export const SET_FILTER_INPUT = 'SET_FILTER_INPUT';

export const GET_PAGINATION = 'GET_PAGINATION';
export const SET_PAGINATION = 'SET_PAGINATION';
